import '../../modules/mode-components';

import * as ng from 'angular';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { AppStore } from '~/types/main.types';
import { ToastService } from '@mode/shared/util-toast';
import { FlamingoTypes } from '@mode/shared/contract-common';
import { CalcEditorModalState } from '@mode/legacy/types-app-state';
import { CalcFieldsService } from '~/services/calc-fields-service';

import template from './calculated-field-view.html';

class CalculatedFieldViewController implements ng.IController {
  static $inject = ['RxStoreService', 'ToastService', 'CalcFieldsService'];

  public description: string;
  // Bindings
  private onEdit: () => void;
  private onClose: () => void;
  private readOnly: boolean;

  // Locals
  private state$: Subscription;
  private calc: FlamingoTypes.ModeCalc;
  private name: string;
  private formula: string;

  constructor(
    private rxStoreService: AppStore,
    private alertService: ToastService,
    private calcFieldsService: CalcFieldsService
  ) {}

  $onInit() {
    this.state$ = this.calcFieldsService.observables.modalStateWithCalc$
      .pipe(filter((state: CalcEditorModalState) => state.isOpen === true))
      .subscribe((state) => {
        const { calc } = state;
        this.calc = calc;
        this.name = calc.name;
        this.formula = calc.formula.source;
      });
  }

  $onDestroy() {
    if (this.state$) {
      this.state$.unsubscribe();
      this.state$ = null;
    }
  }

  onCopySuccess() {
    this.alertService.success('Formula copied to clipboard');
  }
}

const CalculatedFieldViewComponent: ng.IComponentOptions = {
  template: template,
  controller: CalculatedFieldViewController,
  bindings: {
    onEdit: '&',
    onClose: '&',
    readOnly: '<',
  },
};

ng.module('mode.components').component('calculatedFieldView', CalculatedFieldViewComponent);
